module.exports = __webpack_public_path__ + "static/media/logo-mini.c949e51e.svg";